import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { img } from "../../constants/assets";
import { forgotPassword } from "../../services/apiService";
import LanguageSwitcher from "../../components/LanguageSwitcher";

function ForgotPassword() {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: null, message: "" });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ type: null, message: "" });

    const formData = new FormData(event.target);
    const email = formData.get("email")?.trim();

    if (!email) {
      setStatus({ type: "error", message: t("auth.enterEmail") });
      return;
    }

    setIsSubmitting(true);

    try {
      await forgotPassword({ email });
      setStatus({
        type: "success",
        message: t("auth.forgotSuccess"),
      });
      event.target.reset();
    } catch (error) {
      setStatus({
        type: "error",
        message:
          error.response?.data?.message ||
          error.message ||
          t("auth.somethingWrong"),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-lang-switcher-wrap">
        <LanguageSwitcher variant="auth" />
      </div>
      <div className="auth-card">
        <div className="auth-form-panel">
          <div className="auth-form-inner">
            <Link className="auth-logo" to="/">
              <img src={img("logo.svg")} alt="R4L Solutions" />
            </Link>

            <h1 className="auth-title">{t("auth.forgotTitle")}</h1>
            <p className="auth-subtitle">{t("auth.forgotSubtitle")}</p>

            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-field">
                <input
                  id="forgot-password-email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  placeholder=" "
                  required
                  disabled={isSubmitting}
                />
                <label htmlFor="forgot-password-email">{t("common.email")}</label>
              </div>

              <button
                type="submit"
                className="auth-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? t("auth.sending") : t("auth.sendResetLink")}
              </button>

              {status.message ? (
                <p
                  className={`auth-form-status auth-form-status--${status.type}`}
                  role="alert"
                >
                  {status.message}
                </p>
              ) : null}

              <Link className="auth-back-link" to="/login">
                {t("auth.backToLogin")}
              </Link>
            </form>
          </div>
        </div>

        <div className="auth-image-panel">
          <div className="auth-image-wrap">
            <img
              src={img("loginRegister.png")}
              alt={t("auth.authImageAlt")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
